import React from 'react';

const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" aria-hidden="true">
    <path d="M44.44,41.68,34.28,31.52l.16-.22a16.38,16.38,0,1,0-13.07,6.51,16,16,0,0,0,9.89-3.33l.21-.16,10.22,10.1a1.91,1.91,0,0,0,1.4.58,2,2,0,0,0,1.4-.58A2,2,0,0,0,44.44,41.68ZM30.28,30.25a12.26,12.26,0,0,1-8.86,3.66,12.51,12.51,0,1,1,8.85-21.36,12.26,12.26,0,0,1,3.66,8.86A12.46,12.46,0,0,1,30.28,30.25Z"/>
  </svg>
);

export default SearchIcon;
